<template>
    <div class="schedule-select" v-if="disable">
        <el-time-select :picker-options="{start: '00:00',step: '00:15',end: '23:45'}" v-model="time1" placeholder="select" :clearable="false" :editable="false"></el-time-select>
        <el-time-select :picker-options="{start: '00:00',step: '00:15',end: '23:45'}" v-model="time2" placeholder="select" :clearable="false" :editable="false"></el-time-select>
        <el-time-select :picker-options="{start: '00:00',step: '00:15',end: '23:45'}" v-model="time3" placeholder="select" :clearable="false" :editable="false"></el-time-select>
    </div>
</template>

<script>
export default {
    props: ['disable'],
    components: {
    },
    data: function () {
        return {
            time1: null,
            time2: null,
            time3: null,
        };
    },
    mounted() {
    },
    methods: {
        // 每15分钟向上取整
        getNextQuarterHour() {
            let now = new Date();
            let minutes = now.getMinutes();
            let diffMinutes = Math.ceil(minutes / 15) * 15 - minutes;
            now.setMinutes(now.getMinutes() + diffMinutes);
            if (now.getMinutes() === 60) {
                now.setMinutes(0);
                now.setHours(now.getHours() + 1);
            }
            return now;
        },
        //初始化日期
        initDate(schedules) {
            if(schedules&&schedules.times) {
                this.time1 = schedules.times[0];
                this.time2 = schedules.times[1];
                this.time3 = schedules.times[2];
            }else {
                let nowDate = this.getNextQuarterHour();
                let h = nowDate.getHours();
                if (h < 10) {
                    h = '0' + h;
                }
                let m = nowDate.getMinutes();
                if (m < 10) {
                    m = '0' + m;
                }
                this.time1 = h+":"+m;
            }
        },
        //获取当前选中日期
        getRunTime() {
            let times = [this.time1];
            if(this.time2)times.push(this.time2);
            if(this.time3)times.push(this.time3);

            var schedules = {
                type: 'Daily',
                times: times,
            }

            return schedules;
        }
    },
};
</script>

<style scoped>
.schedule-select {
    gap: 10px;/*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_transfer_schedule/tab_daily.vue